module.exports = __webpack_public_path__ + "static/media/apply-mtc.faf23b6f.png";